import React, { useContext, useState, useCallback, useEffect } from 'react'
import { MyContext } from '..';
import Heading from '../GitHubComponents/Heading'
import Button from '../GitHubComponents/Button'
import { Input } from '../GitHubComponents/Inputs'
import { createTeam, fetchUsersBySubscriber } from '../services';
import Alert from '@mui/material/Alert';
import Dropdown from '../GitHubComponents/Dropdown';

export default function NewTeam(props) {
    document.title = props.title
    const { backendUrl } = useContext(MyContext)
    const subscriberCode = props.subCode
    const username = props.username
    const [searchKey, setSearchKey] = useState("")
    const [listItems, setListItems] = useState([])

    const [formData, setFormData] = useState({
        teamName: "",
        description: "",
        subscriberCode: subscriberCode,
        members: []
    });
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })

    const [members, setMembers] = useState([])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can handle form submission logic here
        const response = await createTeam(backendUrl, formData);
        if (response.code === 201) {
            console.log("new team created.");
            setAlert({
                type: "success",
                message: response.message,
                show: true,
            });
        } else {
            setAlert({
                type: "error",
                message: response.message,
                show: true,
            });
        }
    };

    const fetchUsers = useCallback(async () => {
        const data = await fetchUsersBySubscriber(backendUrl, subscriberCode, username, searchKey)
        setListItems(data.users)
    }, [backendUrl, subscriberCode, username, searchKey])

    const handleDropdownInputChange = (e) => {
        setSearchKey(e.target.value)
    }

    useEffect(() => {
        fetchUsers()
    }, [fetchUsers])

    const handleListItemClick = (item) => {
        setFormData(prevFormData => ({ ...prevFormData, members: [...prevFormData.members, item.username] }))
        setMembers(prevMembers => ([...prevMembers, item]))
    }
    return (
        <div className='new-team-body' style={{ display: "grid", placeItems: "center", padding: "2em" }}>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => { setAlert({ show: false }) }} style={{ background: "aliceblue", width: "45vw", margin: "10px auto" }}>{alert.message}</Alert>}
            <div className="inner-new-team-body">
                <Heading heading={"Create new team"} />
                <form onSubmit={handleSubmit}>
                    <Input type={"text"} id={"teamName"} name={"teamName"} lable={"Team name"} description={"You’ll use this name to mention this team in conversations."} value={formData.teamName} onChange={handleChange} minLength={5} required="true" />
                    <Input type={"text"} id={"description"} name={"description"} lable={"Description"} description={"What is this team all about?"} value={formData.description} onChange={handleChange} />
                    <div className="show-selected-items">
                        <label className='git-input-label'>Selected Members</label>
                        <div className="git-basic-div">
                            {members && members.map((member, i) => (
                                <Button key={i} text={member.full_name} />
                            ))}

                        </div>
                    </div>
                    <Dropdown label={"Add Members"} buttonText={"Select user"} dropdownBoxHeading={"Select user"} searchInput={{ placeholder: "Search User", value: searchKey, onChange: handleDropdownInputChange }} listItems={listItems} listItemClick={handleListItemClick} />
                    <Button text={"Create team"} style={{ color: "white ", backgroundColor: "#1f883d", marginTop: "15px" }} />
                </form>
            </div>
        </div>
    )
}
